import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import clsx from 'clsx';
import styled from 'styled-components';
import BailiffContext from 'utils/context/BailiffContext';
import { decodeData } from 'utils/encodeAndDecodeFunctions';
import { bailiffSortOptions } from 'utils/options';
import { getBailiffValueFromState } from 'utils/state-managment/bailiff/bailiffFilter';
import { BailiffFilterReturnData } from 'utils/types/Bailiff';
import { BailiffNoticeSearchingRequestSortTypeEnum } from 'utils/types/BailiffModels';
import { SavedLocationsType } from 'utils/types/V2Locations';

import Indicator from 'components/atom/Indicator';
import BailiffOffers from 'components/bailiff/BailiffOffers';
import FiltersBailiff from 'components/bailiff/FiltersBailiff';
import FiltersContentWrapper from 'components/common/FiltersContentWrapper';
import V2HeaderSection from 'components/V2HeaderSection';

const Container = styled.div`
    padding: 15px 20px 0;
`;

const PageContainer = styled.div`
    height: 100%;
`;

const BailiffPage = () => {
    const { bailiffOfferState, clearOffers, handleChange, loadBailiffOffers, bailiffFiltersState, setLoadingPage, stopLoadingPage, handleFillFilterFields, getSavedFilters } = useContext(BailiffContext);
    const { aiFilterData } = useParams();

    const decodedData = aiFilterData ? decodeData<BailiffFilterReturnData>(aiFilterData) : null;

    useEffect(() => {
        if (decodedData && Object.keys(decodedData).length > 0) {
            setLoadingPage();

            const savedLocations = Object.fromEntries(
                decodedData.locations
                    .filter((loc) => loc.id)
                    .map((loc) => [
                        loc.id,
                        {
                            id: loc.id,
                            label: loc.fullName || ''
                        }
                    ])
            ) as SavedLocationsType;

            const savedOfficeLocations = Object.fromEntries(
                decodedData.officeLocations
                    .filter((loc) => loc.id)
                    .map((loc) => [
                        loc.id,
                        {
                            id: loc.id,
                            label: loc.fullName || ''
                        }
                    ])
            ) as SavedLocationsType;

            const mappedLocations = decodedData.locations
                .filter((loc) => loc.id)
                .map((loc) => ({
                    id: loc.id!,
                    label: loc.fullName || '',
                    children: []
                }));

            const mappedOfficeLocations = decodedData.officeLocations
                .filter((loc) => loc.id)
                .map((loc) => ({
                    id: loc.id!,
                    label: loc.fullName || '',
                    children: []
                }));

            const preparedData = {
                ...decodedData,
                savedLocations,
                savedOfficeLocations,
                city: mappedLocations,
                officeCity: mappedOfficeLocations,
                locations: mappedLocations,
                officeLocations: mappedOfficeLocations,
                searchLocationResult: decodedData.searchLocationResult || [],
                searchOfficeLocationResult: decodedData.searchOfficeLocationResult || []
            };

            handleFillFilterFields(preparedData);
            stopLoadingPage();

            loadBailiffOffers({
                requestData: preparedData as BailiffFilterReturnData
            });
            getSavedFilters();
        }
    }, [aiFilterData]);

    const handleChangeSort = (sortType: string) => {
        handleChange('sortType', sortType);
        loadBailiffOffers({
            requestData: {
                ...getBailiffValueFromState(bailiffFiltersState),
                sortType: sortType as BailiffNoticeSearchingRequestSortTypeEnum
            },
            page: 1,
            rows: 25
        });
    };

    // const handleCSVFile = useCallback(() => {
    //     saleOffersApiRequests.getSaleOffersCSVFile(getSaleValueFromState(saleFiltersState), getNormalizedSaleModuleName(saleFiltersState.module));
    // }, [saleFiltersState]);

    return (
        <PageContainer>
            <V2HeaderSection
                title={'Informacje o zadłużeniach'}
                offersCount={bailiffOfferState.bailiffOfferList?.totalElements}
                sortType={bailiffOfferState.bailiffOfferList.content?.length ? bailiffOfferState.sortType : undefined}
                sortOptions={bailiffSortOptions}
                handleChangeSort={handleChangeSort}
                handleBackToFilters={bailiffOfferState.bailiffOfferList.content?.length || bailiffOfferState.bailiffOfferList.empty ? clearOffers : undefined}
            />
            <FiltersContentWrapper className={clsx('offers-list', { active: bailiffOfferState.bailiffOfferList?.content && bailiffOfferState.bailiffOfferList?.content.length > 0 || bailiffOfferState.bailiffOfferList?.empty })}>
                <Container id="filters">
                    <FiltersBailiff/>
                </Container>
                <BailiffOffers/>
                {bailiffOfferState.isLoading && <Indicator/>}
            </FiltersContentWrapper>
        </PageContainer>
    );
};

export default BailiffPage;
